import { render, staticRenderFns } from "./ProductBagReceiving.vue?vue&type=template&id=38ae0046&scoped=true&"
import script from "./ProductBagReceiving.vue?vue&type=script&lang=js&"
export * from "./ProductBagReceiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae0046",
  null
  
)

export default component.exports